import React, { useState } from 'react';
import InSkiDownloadView from '../InSki-Components/InSkiDownloadView';
import StonkDownloadView from '../Stonk-Components/StonkDownloadView';

function FeaturedCarousel() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const items = [
        { component: <InSkiDownloadView />, id: 0 },
        { component: <StonkDownloadView />, id: 1 }
    ];

    const goToSlide = (index) => {
        setCurrentIndex(index);
    };

    const goToPrev = () => {
        setCurrentIndex((prev) => (prev === 0 ? items.length - 1 : prev - 1));
    };

    const goToNext = () => {
        setCurrentIndex((prev) => (prev === items.length - 1 ? 0 : prev + 1));
    };

    return (
        <div className="featured-carousel-container">
            {/* Arrow buttons */}
            <button
                className="carousel-arrow carousel-arrow-left"
                onClick={goToPrev}
                aria-label="Previous slide"
            >
                &#8592;
            </button>

            {/* Carousel content */}
            <div className="featured-carousel-content">
                {items[currentIndex].component}
            </div>

            <button
                className="carousel-arrow carousel-arrow-right"
                onClick={goToNext}
                aria-label="Next slide"
            >
                &#8594;
            </button>

            {/* Dots navigation */}
            <div className="carousel-dots">
                {items.map((item, index) => (
                    <button
                        key={item.id}
                        className={`carousel-dot ${index === currentIndex ? 'active' : ''}`}
                        onClick={() => goToSlide(index)}
                        aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>
        </div>
    );
}

export default FeaturedCarousel;
